import React from 'react';

const RefreshIcon = ({ size = 22, color = '#A82121' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.76 0.750005V3.882C18.7602 3.94672 18.7404 4.00991 18.7033 4.06293C18.6662 4.11596 18.6136 4.15622 18.5528 4.17822C18.4919 4.20022 18.4257 4.20288 18.3633 4.18584C18.3009 4.1688 18.2452 4.13288 18.204 4.083C17.2667 3.03333 16.1181 2.19373 14.8335 1.61931C13.5488 1.04489 12.1572 0.748639 10.75 0.750005C5.227 0.750005 0.75 5.22701 0.75 10.75C0.75 16.273 5.227 20.75 10.75 20.75C16.273 20.75 20.75 16.273 20.75 10.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default RefreshIcon;
